import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class BaseControl extends Vue {
    @Prop() value: any;
    @Prop({ default: "" }) placeholder: string | undefined;
    @Prop({ default: false }) disabled: boolean;

    get model() {
        return this.value;
    }

    set model(value) {
        this.$emit('input', value);
    }
}